import React from "react"
import PropTypes from "prop-types"

import Dialog, { DialogContent, DialogContentText, DialogTitle, DialogActions } from "ui-Dialog"
import Button from "@material-ui/core/Button"

export default class ConfirmationDialog extends React.Component {
  static propTypes = {
    actions: PropTypes.node,
    cancelLabel: PropTypes.string,
    okLabel: PropTypes.string,
    title: PropTypes.string,

    onOk: PropTypes.func,
    onCancel: PropTypes.func,
  }

  _renderActions() {
    const {
      actions,
      cancelLabel,
      okLabel,

      onOk,
      onCancel,
    } = this.props

    if (actions) {
      return actions
    }

    return [
      <Button key="cancel" color="primary" onClick={onCancel}>
        {cancelLabel || "Cancel"}
      </Button>,
      <Button key="ok" color="primary" onClick={onOk}>
        {okLabel || "OK"}
      </Button>,
    ]
  }

  render() {
    const {
      actions,
      cancelLabel,
      children,
      okLabel,
      title,

      onOk,
      onCancel,

      ...otherProps
    } = this.props

    return (
      <Dialog {...otherProps}>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
          <DialogContentText>{children}</DialogContentText>
        </DialogContent>
        <DialogActions>{this._renderActions()}</DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ConfirmationDialog/ConfirmationDialog.js